import '../../immer-init';
import '../../dev-console-filter';
import '../../core/session-storage-observer';
import('./bootstrap').catch((err) => console.error(err));
